import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tagIndex:'0'
  },
  getters: {
  },
  mutations: {
    changeCommit(state, value) {
      state.tagIndex = value;
    }
  },
  actions: {
    changeDispatch(context, value) {
      context.commit('changeCommit', value);
    }
  },
  modules: {
  }
})
